import { client } from "../../../api/client"
export const saveBanner = async (banner) => {
    if (process.env.REACT_APP_USELOCALDATA === "true") {
        return 200
    } else {
        return await client.post("campaigns/campaigns", JSON.stringify(banner))
    }
}